module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-primary"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.summaryData.totalLeads || 0))]), _vm._v(" "), _c('p', [_vm._v("Total Leads")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-success"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.summaryData.convertedLeads || 0))]), _vm._v(" "), _c('p', [_vm._v("Converted Leads")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-warning"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.summaryData.pendingLeads || 0))]), _vm._v(" "), _c('p', [_vm._v("Pending Leads")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-info"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.formatCurrency(_vm.summaryData.totalRevenue || 0)))]), _vm._v(" "), _c('p', [_vm._v("Total Revenue")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-danger"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.summaryData.totalQuotations || 0))]), _vm._v(" "), _c('p', [_vm._v("Total Quotations")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-secondary"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s((_vm.summaryData.usedBookings || 0) + '/' + (_vm.summaryData.totalBookings || 0)))]), _vm._v(" "), _c('p', [_vm._v("Used/Total Bookings")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-success"
  }, [_c('i', {
    staticClass: "fa fa-percent"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.summaryData.assignmentRate || 0))]), _vm._v(" "), _c('p', [_vm._v("Total Assignments")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-primary"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.summaryData.activeClients || 0))]), _vm._v(" "), _c('p', [_vm._v("Active Clients (90d)")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-warning"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.formatCurrency(_vm.summaryData.outstandingAmount || 0)))]), _vm._v(" "), _c('p', [_vm._v("Outstanding Amount")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6fa014","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/SummaryCards.vue
// module id = 2775
// module chunks = 0